module.exports = __webpack_public_path__ + "img/play.feee04a6.png";